import { FaUserTie, FaMoneyBillWave, FaTools, FaChartBar, FaClinicMedical, FaShieldAlt, FaSeedling, FaTint, FaBook, FaHospital, FaChalkboardTeacher, FaWater, FaRoad, FaUserShield } from 'react-icons/fa';
import IgboezeEvent from './images/igboeze-event.jpg';
import IgboezeHealthcare from './images/igboeze-healthcare.jpg';
import IgboezeCulture from './images/igboeze-culture.jpg';
import IgboezeCulturalFestival from './images/igboeze-cultural-festival.jpg';
import IgboezeHealthcareOutReach from './images/igboeze-healthcare-outreach.jpg';
import IgboezeConstructionProject from './images/igboeze-construction-project.jpg';
import IgboezeSchoolVisits from './images/igboeze-school-visit.jpg'
import IgboezeWomenEmpowerment from './images/igboeze-women-empowerment.jpg'
import IgboezeNorthBuilding from './images/igboeze-north-building.JPG'
import SolarBoreHole from './images/igboeze-solar-borehole.png'
import IgboezeEducationalEmpowerment from './images/igboeze-educational-empowerment.jpg'
import IgboezeHealthCenterRenovation from './images/igboeze-hospital-renovation.png'
// 📁 quillConfig.js

import Quill from 'quill';

// 🔹 1. Register the custom VideoBlot before anything else
const BlockEmbed = Quill.import('blots/block/embed');

class VideoBlot extends BlockEmbed {
  static create(value) {
    const node = super.create();
    node.setAttribute('src', value);
    node.setAttribute('frameborder', '0');
    node.setAttribute('allowfullscreen', true);
    node.setAttribute(
      'allow',
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
    );
    node.setAttribute('width', '100%');
    node.setAttribute('height', '400');
    return node;
  }

  static value(node) {
    return node.getAttribute('src');
  }
}

VideoBlot.blotName = 'video';
VideoBlot.tagName = 'iframe';

Quill.register(VideoBlot); // ✅ register it BEFORE exporting modules or formats

// 🔹 2. Export your Quill configuration
export const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ color: [] }, { background: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ align: [] }],
    ['link', 'image'],
    ['clean'],
  ],

  handlers: {
    image: function () {
      const input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.setAttribute('accept', 'image/*');
      input.click();
      input.onchange = () => {
        const file = input.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = () => {
            const quill = this.quill;
            const range = quill.getSelection();
            quill.insertEmbed(range.index, 'image', reader.result); // Insert base64 image
          };
          reader.readAsDataURL(file);
        }
      };
    }
  },

  clipboard: {
    matchVisual: false,
    matchers: [
      ['A', (node, delta) => {
        const href = node.getAttribute('href');
        if (!href) return delta;

        try {
          const url = new URL(href);
          let videoId = null;

          if (url.hostname.includes('youtu.be')) {
            videoId = url.pathname.slice(1);
          } else if (url.hostname.includes('youtube.com')) {
            videoId = url.searchParams.get('v');
          }

          if (videoId) {
            return {
              ops: [
                {
                  insert: { video: `https://www.youtube.com/embed/${videoId}` },
                },
              ],
            };
          }
        } catch (err) {
          console.error('Invalid YouTube URL:', err);
        }

        return delta;
      }],
    ],
  },
};

export const formats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'color',
  'background',
  'list',
  'bullet',
  'align',
  'link',
  'image',
  'video', // ✅ required for YouTube embed to work
];

// export const modules = {
//   toolbar: [
//     [{ 'header': [1, 2, false] }],
//     ['bold', 'italic', 'underline', 'strike'],
//     [{ 'color': [] }, { 'background': [] }], // ✅ Add text and background color pickers
//     [{ 'list': 'ordered' }, { 'list': 'bullet' }],
//     [{ 'align': [] }],
//     ['link', 'image'],
//     ['clean']
//   ],

//   clipboard: {
//     matchVisual: false,
//     // You can add a custom paste handler for YouTube links here
//     // For paste detection (YouTube link)
//     // This will check if a user pastes a YouTube link
//     matchers: [
//       ['a[href*="youtube.com/watch"], a[href*="youtu.be/"]', (node) => {
//         const url = new URL(node.getAttribute('href'));
//         let videoId = null;
//         if (url.hostname.includes('youtu.be')) {
//           videoId = url.pathname.slice(1);
//         } else {
//           videoId = url.searchParams.get('v');
//         }
//         if (videoId) {
//           const iframe = document.createElement('iframe');
//           iframe.src = `https://www.youtube.com/embed/${videoId}`;
//           iframe.width = '100%';
//           iframe.height = '400';
//           iframe.frameBorder = '0';
//           iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
//           iframe.allowFullscreen = true;
//           node.replaceWith(iframe);
//         }
//       }],
//     ],
//   },
// };


export const quickLinks = [
  { title: 'Health', path: '/departments/health' },
  { title: 'Education', path: '/departments/education' },
  { title: 'Achievements', path: '/achievements' },
  { title: 'Scholarships', path: '/news-events/scholarships' },
];

export const councilMembers = [
  {
    name: "Hon. John Doe",
    role: "Chairman",
    image: "/images/john-doe.jpg",
    bio: "Brief intro about the chairman."
  },
  {
    name: "Jane Doe",
    role: "Vice Chairman",
    image: "/images/jane-doe.jpg",
    bio: "Short profile here."
  }
];

export const coreValues = ["Transparency", "Development", "Community Engagement"];

export const departments = [
  "Health",
  "Education",
  "Infrastructure",
  "Youth & Sports",
  "Agriculture",
  "Security & Safety"
];

export const services = [
  {
    icon: <FaHospital />,
    title: 'Healthcare',
    description: 'Accessible and quality health services across all communities.'
  },
  {
    icon: <FaChalkboardTeacher />,
    title: 'Education',
    description: 'Investing in schools, training, and learning opportunities.'
  },
  {
    icon: <FaWater />,
    title: 'Water Supply',
    description: 'Providing clean and safe water to every household.'
  },
  {
    icon: <FaRoad />,
    title: 'Infrastructure',
    description: 'Developing rural and urban roads, electricity, and more.'
  },
  {
    icon: <FaUserShield />,
    title: 'Security',
    description: 'Partnering with agencies to ensure community safety.'
  },
  {
    icon: <FaSeedling />,
    title: 'Agriculture',
    description: 'Supporting farmers with tools, training, and access to markets.'
  }
];

export const newsEvents = [
  {
    title: "Igbo-Eze North Development Plan Unveiled",
    description: "The Chairman has announced the new development plans for Igbo-Eze North, including infrastructure upgrades, new schools, and healthcare initiatives.",
    image: IgboezeEvent,
    link: "/news/igboeze-north-development-plan"
  },
  {
    title: "Annual Cultural Festival Scheduled",
    description: "The much-awaited annual cultural festival will take place in December, celebrating Igbo culture with music, dance, and food.",
    image: IgboezeCulture,
    link: "/events/annual-cultural-festival"
  },
  {
    title: "Healthcare Campaign for Rural Communities",
    description: "A new healthcare campaign targeting rural areas to provide free medical check-ups and medications is launching next week.",
    image: IgboezeHealthcare,
    link: "/news/healthcare-campaign-rural"
  }
];

export const galleryImages = [
  {
    image: IgboezeHealthcareOutReach,
    caption: "Community Health Outreach"
  },
  {
    image: IgboezeCulturalFestival,
    caption: "Cultural Festival 2024"
  },
  {
    image: IgboezeConstructionProject,
    caption: "Road Construction Project"
  },
  {
    image: IgboezeSchoolVisits,
    caption: "Chairman Visits Local Schools"
  },
  {
    image: IgboezeWomenEmpowerment,
    caption: "Igbo-Eze North Women Empowerment"
  },
  {
    image: IgboezeNorthBuilding,
    caption: "Igbo-Eze North Building Projects"
  }
];

export const achievements = [
  {
    image: IgboezeConstructionProject,
    title: "Rehabilitation of Rural Roads",
    description: "Over 20km of rural roads were graded and rehabilitated to ease transportation."
  },
  {
    image: IgboezeHealthCenterRenovation,
    title: "Health Center Renovation",
    description: "Upgraded 5 primary health centers with modern facilities and staff quarters."
  },
  {
    image: IgboezeEducationalEmpowerment,
    title: "Educational Empowerment",
    description: "Distributed school supplies to 500+ students across 15 primary schools."
  },
  {
    image: SolarBoreHole,
    title: "Water Projects",
    description: "Drilled 10 solar-powered boreholes in remote communities."
  }
];

export const ourDepartments = [
  {
    icon: <FaUserTie />,
    title: "Administration",
    description: "Oversees internal coordination, communication, personnel, and Council activities.",
    link: "administration"
  },
  {
    icon: <FaMoneyBillWave />,
    title: "Finance & Accounts",
    description: "Manages budgeting, financial reporting, revenue generation, and FAAC allocations.",
    link: "finance-accounts"
  },
  {
    icon: <FaTools />,
    title: "Works & Housing",
    description: "Handles roads, public buildings, housing projects, and infrastructure maintenance.",
    link: "works-housing"
  },
  {
    icon: <FaChartBar />,
    title: "Planning, Research & Statistics (PRS)",
    description: "Leads development planning, data management, M&E, and donor coordination.",
    link: "reports"
  },
  {
    icon: <FaClinicMedical />,
    title: "Health Care",
    description: "Provides healthcare services, immunizations, WASH, and health education.",
    link: "health"
  },
  {
    icon: <FaShieldAlt />,
    title: "Security & Safety",
    description: "Ensuring a safe and secure environment for all citizens of Igboeze North.",
    link: "security-safety"
  },
  {
    icon: <FaSeedling />,
    title: "Agriculture & Veterinary",
    description: "Supports farmers, agro-processing, animal health, and food security programs.",
    link: "agriculture"
  },
  {
    icon: <FaTint />,
    title: "WASH Department",
    description: "Ensures water access, sanitation infrastructure, and hygiene promotion.",
    link: "wash"
  },
  {
    icon: <FaBook />,
    title: "Education & Community Development",
    description: "Oversees schools, learning materials, scholarships, and social empowerment.",
    link: "education"
  }
];

export const feedbacks = [
  {
    message: "Igbo-Eze North has made great strides in healthcare delivery and community development.",
    name: "Chinwe U.",
    role: "Community Health Worker"
  },
  {
    message: "The leadership is transparent and inclusive. We're proud to call this place home.",
    name: "Eze N.",
    role: "Traditional Ruler"
  },
  {
    message: "The support for education and scholarships is commendable. I benefitted personally.",
    name: "Obinna M.",
    role: "Student"
  }
];

export const stats = [
  { label: 'Wards', value: 14 },
  { label: 'Communities', value: 27 },
  { label: 'Projects Executed', value: 120 },
  { label: 'Schools', value: 45 },
];

export const educationStats = [
  { label: "Primary Schools", value: 112 },
  { label: "Teachers", value: 543 },
  { label: "Students", value: 12530 },
  { label: "Scholarship Beneficiaries", value: 308 },
];

export const educationPrograms = [
  {
    title: "Scholarship Schemes",
    desc: "Supporting brilliant but underprivileged students to access quality education.",
  },
  {
    title: "Teacher Training",
    desc: "Continuous development programs to improve teaching standards.",
  },
  {
    title: "School Renovation",
    desc: "Ongoing infrastructure improvements across primary and secondary schools.",
  },
];

export const newsEventsData = [
  {
    id: 1,
    title: 'Free Medical Outreach in Igbo-Eze North',
    date: 'March 15, 2025',
    description: 'The local government hosted a medical outreach program to provide free health checkups and medicine to residents.',
    image: IgboezeHealthcareOutReach
  },
  {
    id: 2,
    title: 'Annual Cultural Festival 2025',
    date: 'February 5, 2025',
    description: 'Traditional leaders and cultural troupes gathered to celebrate heritage and promote unity in Igbo-Eze North.',
    image: IgboezeCulturalFestival
  },
  {
    id: 3,
    title: 'Youth Empowerment Seminar Held in Unadu',
    date: 'January 20, 2025',
    description: 'The local government organized an empowerment seminar for youth, focusing on skill acquisition and entrepreneurship.',
    image: IgboezeEvent
  }
];

export const villages = [
  // Villages in Ibagwa-Aka
  'Amaebo',
  'Amankpu-Ibagwa',

  // Villages in Ovoko
  'Ama-Agu-Ovoko',
  'Amachalla-Ovoko',
  'Umu-Ezeavlu-Ovoko',

  // Villages in Ezzodo
  'Uda I',
  'Uda II',
  'Uda III',
  'Uroshi',
  'Uloche'
];

export const towns = [
  'Enugu-Ezike',
  'Etteh',
  'Umuozzi',
  'Umuitodo',
  'Ezzodo',
  'Essodo',
  'Ibagwa-Aka',
  'Ovoko'
];

export const educationLevels = ['nursery', 'primary', 'junior secondary', 'senior secondary', 'n c e', 'national diploma', 'higher national diploma', "bachelor's degree", 'p g d', "master's degree", "doctorate degree"];
export const occupations = ['student', 'trader', 'engineer', 'nurse', 'doctor', 'pharmacist', 'teacher', 'apprentice', 'sale boy', 'sale girl', 'others'];
export const rolesList = ['user', 'admin', 'editor', 'education', 'health', 'security', 'agriculture', 'wash', 'works', 'finance', 'events & media'];
export const stateOfResidence = ['abia', 'anambra', 'enugu', 'ebonyi', 'imo'];
export const roles = ['user', 'admin', 'administration', 'education', 'health', 'security', 'agriculture', 'wash', 'works', 'finance', 'events & media'];
export const reportCategories = ['medium term development plan', 'annual budget', 'annual financial accounts', 'fiscal performance reports', 'Others'];
export const postCategories = ['uncategorized', 'tender & procurements', 'our projects', 'education', 'health', 'security', 'agriculture', 'wash', 'works', 'finance', 'events & media'];
export const memberCategories = [
  'Chairman',
  'Vice Chairman',
  'Leader',
  'Head of Personnel Management',
  'Special Adviser – Administration',
  'Special Adviser – Political',
  'Finance Supervisor',
  'Health Supervisor',
  'Education Supervisor',
  'Agriculture Supervisor',
  'Works Supervisor',
  'Head of Administration',
  'Treasurer (Head of Finance and Accounts)',
  'Town Engineer (Head of Works)',
  'Head of Planning, Research and Statistics',
  'Head of Education, Community Development and Social Welfare',
  'Head of Health and Medical Services',
  'Head of Agriculture and Veterinary Services',
  'Head of WASH',
  'Councillor – Leader',
  'Councillor – Deputy Leader',
  'Councillor – Majority Leader',
  'Councillor – Minority Leader',
  'Councillor – Chief Whip',
  'Uncategorized'
];
export const headOfDepartments = [
  {
    image: IgboezeConstructionProject,
    name: "Victor Okechukwu",
    description: "HOD Administration",
    link: "administration"
  },
  {
    image: IgboezeConstructionProject,
    name: "Chinwe Ako",
    description: "HOD Agriculture",
    link: "agriculture"
  },
  {
    image: IgboezeConstructionProject,
    name: "Onyeoma Udengwu",
    description: "HOD Education",
    link: "education"
  },
  {
    image: IgboezeConstructionProject,
    name: "Uju Nwankwo",
    description: "HOD Health",
    link: "health"
  },
  {
    image: IgboezeConstructionProject,
    name: "Onyeoma Udengwu",
    description: "HOD Security & Safety",
    link: "security-safety"
  },
  {
    image: IgboezeConstructionProject,
    name: "Emeka Ozioko",
    description: "HOD WASH",
    link: "wash"
  },
  {
    image: IgboezeHealthcare,
    name: "Adaku Udo",
    description: "HOD Budget & Finance",
    link: "finance-accounts"
  },
  {
    image: IgboezeHealthcare,
    name: "Ndidi Attamah",
    description: "HOD Works & Housing",
    link: "works-housing"
  },
];